import type { ColumnsType } from "antd/es/table"
import dayjs from "dayjs"
import React from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

import { empty } from "../../../../constants/placeholders"
import { RoutesPaths } from "../../../../constants/routes.ts"
import { leadStatusStyles } from "../../../Lead/constants/lead-statuses.ts"
import { LeadPill } from "../../../Leads/components/LeadPill.tsx"
import { type LeadListItem } from "../../../Leads/types/types.ts"
import { type CustomerRelatedList } from "../redux/customer-detail.types.ts"
import { CustomerRelatedCard } from "./CustomerRelatedCard.tsx"

interface CustomerRelatedLeadsProps {
  leads: CustomerRelatedList<LeadListItem>
  onLoadMore: () => void
}

function CustomerRelatedLeads({
  leads,
  onLoadMore
}: CustomerRelatedLeadsProps) {
  const { t } = useTranslation()

  const columns: ColumnsType<LeadListItem> = [
    {
      title: t("customerDetail.leads.columns.name"),
      dataIndex: "lead_name",
      key: "lead_name",
      render: (name: string | null, record) => (
        <Link to={RoutesPaths.lead.view(record.id)}>
          {name || record.uid || empty}
        </Link>
      )
    },
    {
      title: t("customerDetail.leads.columns.stage"),
      dataIndex: "status",
      key: "status",
      width: 150,
      render: (status: string) =>
        status ? (
          <LeadPill style={leadStatusStyles?.[status]}>{status}</LeadPill>
        ) : (
          empty
        )
    },
    {
      title: t("customerDetail.leads.columns.created"),
      dataIndex: "created",
      key: "created",
      width: 140,
      render: (created: string | null) =>
        created ? dayjs(created).format("MMM D, YYYY") : empty
    }
  ]

  return (
    <CustomerRelatedCard<LeadListItem>
      testId={"customer-related-leads"}
      title={t("customerDetail.leads.title")}
      emptyText={t("customerDetail.leads.empty")}
      columns={columns}
      rows={leads.results}
      count={leads.count}
      next={leads.next}
      retryNext={leads.retryNext}
      loading={leads.fetching}
      onLoadMore={onLoadMore}
    />
  )
}

export { CustomerRelatedLeads }
